import * as types from '../../actions/types';

const initialState = {
  posts: [],
  isLoading: false,
  error: null,
};

const blogPost = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BLOG_POSTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_BLOG_POSTS_SUCCESS:
      return {
        ...state,
        posts: action.payload,
        isLoading: false,
        error: null,
      };
    case types.GET_BLOG_POSTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case types.CREATE_BLOG_POST_SUCCESS:
    case types.UPDATE_BLOG_POST_SUCCESS:
    case types.DELETE_BLOG_POST_SUCCESS:
    case types.PUBLISH_BLOG_POST_SUCCESS:
    case types.UNPUBLISH_BLOG_POST_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default blogPost;